import produce from 'immer';
import * as CONSTANTS from './constants';

const initialState = {
  unreadMessageCount: 0,
  chatId: null,
  error: null,
};

const messagesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.SET_UNREAD_MESSAGE_COUNT:
        draft.unreadMessageCount = action.count;
        break;
      case CONSTANTS.SET_CHAT_ID:
        draft.chatId = action.chatId;
        break;
      case CONSTANTS.MESSAGES_ERROR:
        draft.error = action.error;
        break;
      default:
        break;
    }
  });

export default messagesReducer;
